import { create } from "zustand";

import { Customer } from "../models/Customer";

type State = Customer;

type Actions = {
  setCustomer: (state: Customer) => void;
  setUnlockCustomer: (id: string, status: string) => void;
};

const customerStore = create<State & Actions>(set => ({
  // State
  users: [],
  pagination: {
    currentPage: 1,
    pageSize: 12,
    totalPages: 0,
  },

  setCustomer: newState =>
    set(() => ({
      ...newState,
    })),

  setUnlockCustomer: (id, status) =>
    set(state => ({
      ...state,
      users: state.users.map(item =>
        item.omneId === id ? { ...item, accountStatus: "VERIFIED" } : item,
      ),
    })),
}));

export const useCustomerStore = () => {
  return customerStore(store => ({
    users: store.users,
    pagination: store.pagination,
  }));
};

export const useSetCustomerStore = () => {
  return customerStore(store => store.setCustomer);
};

export const useSetUnlockCustomerStore = () => {
  return customerStore(store => store.setUnlockCustomer);
};
